// eslint-disable-next-line no-shadow
enum NotificationsActionTypes {
  ADD_NOTIFICATION = "ADD_NOTIFICATION",
  REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION",
  CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS",
}

export default NotificationsActionTypes;
